import { VpArrowForwardIcon } from '@vtmn-play/icons/react'
import { VpIcon, VpIconButton } from '@vtmn-play/react'
import { getMyGameLanguage } from 'core/utils/i18n'
import { VtmnTooltip } from '@vtmn/react'
import { useTranslation } from 'react-i18next'

const formatDateRange = (from: Date, to: Date): string => {
  if (from == null || to == null) return ''

  const formatter = new Intl.DateTimeFormat(getMyGameLanguage(), {
    month: 'short',
    day: 'numeric'
  })

  return `(${formatter.format(from)} - ${formatter.format(to)})`
}

type LastFourWeeksStorePerformanceHeaderProps = {
  from?: Date | null
  to?: Date | null
  onOpenDetails: () => void
}

const LastFourWeeksStorePerformanceHeader = ({ from, to, onOpenDetails }: LastFourWeeksStorePerformanceHeaderProps) => {
  const { t } = useTranslation()
  const dateRange = formatDateRange(from, to)

  return (
    <header className="mg-last-four-weeks-store-performance-header">
      <div className="mg-last-four-weeks-store-performance-header-content">
        <div className="vp-subtitle-l">{t('homepage.last-four-weeks-store-performance.title')}</div>
        <div className="vp-body-s">{dateRange}</div>
        <div className="mg-last-four-weeks-store-performance-header-tooltip">
          <VtmnTooltip position="top-right" tooltip={t('homepage.last-four-weeks-store-performance.tooltip')}>
            <VpIcon {...({ name: 'information', size: 22 } as any)} />
          </VtmnTooltip>
        </div>
      </div>

      <div>
        <VpIconButton
          variant="secondary"
          variantStyle="regular"
          size="small"
          type="button"
          data-testid="last-four-weeks-store-performance-details-button"
          onClick={onOpenDetails}
        >
          <VpArrowForwardIcon fontSize={16} />
        </VpIconButton>
      </div>
    </header>
  )
}

export default LastFourWeeksStorePerformanceHeader
